class TokenService {
  constructor(serviceBase) {
    this.serviceBase = serviceBase;
  }

  login(data) {
    return this.serviceBase.create(data);
  }

  getUserInfo(params) {
    return this.serviceBase.getResourceAction('user-info', params);
  }

  refresh(data) {
    return this.serviceBase.postResourceAction('refresh', data);
  }
}

export default TokenService;



// WEBPACK FOOTER //
// ./src/services/TokenService.js